import { Button, Input, Select, Form } from "antd";
import inquiryJson from "./inquiry.json";
import { iconsAndImages } from "../../assets/images";
import { openWhatsApp } from "../../utils";
import "./style.scss";
import { MdPhoneIphone } from "react-icons/md";

const { TextArea } = Input;

export const SrkInquiry = () => {
    const onFinish = (values) => {
        console.log("Form Data:", values);
    };

    return (
        <>
            <section className="contact-section text-center py-5">
                <div className="container py-5">
                    <h2 className="bebas-neue-regular">
                        Contact
                    </h2>
                    <p className="contact-sub">
                        Let’s connect for business inquiries and collaborations
                    </p>
                </div>
            </section>
            <section>
                <div className="container py-5">
                    <div className="row align-items-center g-4">
                        <div className="col-12 col-lg-6">
                            <h1 className="bebas-neue-regular">{inquiryJson?.title}</h1>
                            <p>{inquiryJson?.subContent}</p>
                            <Form layout="vertical" onFinish={onFinish}>
                                <div className="row g-3">
                                    <div className="col-12 col-md-6">
                                        <Form.Item
                                            label="Your Name"
                                            name="name"
                                            rules={[{ required: true, message: "Please enter your name" }]}
                                        >
                                            <Input placeholder="Name" />
                                        </Form.Item>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <Form.Item
                                            label="Company Name"
                                            name="company"
                                            rules={[{ required: true, message: "Please enter company name" }]}
                                        >
                                            <Input placeholder="Business Ltd." />
                                        </Form.Item>
                                    </div>
                                </div>
                                <Form.Item
                                    label="Email Address"
                                    name="email"
                                    rules={[
                                        { required: true, message: "Please enter email" },
                                        { type: "email", message: "Enter valid email" }
                                    ]}
                                >
                                    <Input placeholder="john@example.com" />
                                </Form.Item>
                                <Form.Item
                                    label="Product Interest"
                                    name="product"
                                    rules={[{ required: true, message: "Please select product" }]}
                                >
                                    <Select
                                        placeholder="Select"
                                        options={[
                                            { value: "tiles", label: "Tiles" },
                                            { value: "granite", label: "Granite" },
                                            { value: "export", label: "Export Order" }
                                        ]}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Inquiry Details"
                                    name="details"
                                    rules={[{ required: false, message: "Please enter details" }]}
                                >
                                    <TextArea rows={4} placeholder="Tell us about your requirements..." />
                                </Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    size="large"
                                    className="w-100"
                                >
                                    Send Inquiry
                                </Button>
                            </Form>
                        </div>
                        <div className="col-12 col-lg-6">
                            <div
                                style={{ backgroundColor: "#FAF8F3" }}
                                className="rounded p-4 p-md-5 shadow-sm"
                            >
                                <h3>{inquiryJson?.propriterName}</h3>
                                <p style={{ fontSize: "13px" }} className="fw-bold">
                                    {inquiryJson?.position}
                                </p>
                                <p className="text-color">{inquiryJson?.details}</p>
                                <div className="mb-4">
                                    <p className="text-color d-flex align-items-center gap-2">
                                        <img loading="lazy" src={iconsAndImages[inquiryJson?.map]} alt="" width="18" />
                                        {inquiryJson?.location}
                                    </p>
                                    <p className="text-color d-flex align-items-center gap-2">
                                        <img loading="lazy" src={iconsAndImages[inquiryJson?.emailIcon]} alt="" width="18" />
                                        <a style={{ color: "#1D3B5F" }}
                                            href={`mailto:${inquiryJson?.email1}?subject=${encodeURIComponent("Product Inquiry")}&body=${encodeURIComponent("Hi, I am interested in your products. Please share more details.")}`}
                                        >
                                            {inquiryJson?.email1}
                                        </a> |
                                        <a style={{ color: "#1D3B5F" }} href={`mailto:${inquiryJson?.email}?subject=${encodeURIComponent("Product Inquiry")}&body=${encodeURIComponent("Hi, I am interested in your products. Please share more details.")}`}>{inquiryJson?.email}</a>
                                    </p>
                                    <p>
                                        <MdPhoneIphone style={{ color: "#1D3B5F", fontSize: "20px" }} />
                                        <a style={{ color: "#1D3B5F" }} href={`tel:${inquiryJson?.phoneNo}`}>
                                            {inquiryJson?.phoneNo}
                                        </a>
                                    </p>
                                </div>
                                <Button
                                    size="large"
                                    className="w-100 text-light d-flex align-items-center justify-content-center gap-2"
                                    style={{ backgroundColor: "#16A34A", border: "none" }}
                                    onClick={() => openWhatsApp()}
                                >
                                    <img
                                        loading="lazy"
                                        src={iconsAndImages[inquiryJson?.phone]}
                                        alt=""
                                        width="18"
                                    />
                                    Direct Chat with Abarna
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <iframe title="srk-draders" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3930.1734310758716!2d78.11676687315627!3d9.919509774418389!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c58461e46987%3A0xf134621ce5286703!2sMeenakshi%20Amman%20Temple!5e0!3m2!1sen!2sin!4v1773852159237!5m2!1sen!2sin" height="300" style={{ border: 0, width: "100%" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </section>
        </>
    );
};